import React, { useState } from "react";
import { AddToolTip } from "../../../components";
import { useDeepEffect } from "../../../abstracts";
import TieredParticiantBalance from "../CalculationContainer/TieredParticipantBalance";

const FeeCalculation = ({ feeCalculationResponse }) => {
  console.log("hhhhhuii", feeCalculationResponse);

  return (
    <div className="fee-summary-conatiner calculation-container-fee">
      <div className="fee-applicable">
        <div className="schedule-run">
          <span className="fw-500 mt-4 ft-14 headerDetails">
            Fee type
            {feeCalculationResponse?.feeType == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"Balance Based"}</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Investment Based"}</p>
            )}
          </span>
          {feeCalculationResponse?.feeType == 2 && (
            <span className="fw-500 mt-4 ft-14 headerDetails">
              Investment name and CUSIP
              <p className="fw-600 ft-16 valueDetails">
                {feeCalculationResponse?.investmentName}
              </p>
              <p
                style={{ marginTop: "-16px" }}
                className="fw-500 ft-14 valueDetails"
              >
                {feeCalculationResponse?.cusip}
              </p>
            </span>
          )}

          <span className="fw-500 mt-4 ft-14 headerDetails">
            Process Minimum Amount
            {feeCalculationResponse?.processMinAmount == true ? (
              <p className="fw-600 ft-16 valueDetails">Yes</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">No</p>
            )}
          </span>
          <span
            className="fw-500 ft-14 headerDetails mt-4"
            style={{ whiteSpace: "normal" }}
          >
            Minimum Threshold – Participant Balance
            {feeCalculationResponse?.minimumThresholdBalance == null ? (
              <p className="fw-600 ft-16 valueDetails"> - </p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">
                ${feeCalculationResponse?.minimumThresholdBalance}
              </p>
            )}
          </span>
          <span
            className="mt-4 fw-500 ft-14 headerDetails"
            style={{ whiteSpace: "normal" }}
          >
            Percentage of Account balance considered for Fee Deduction
            {feeCalculationResponse?.minimumThresholdBalance == null ? (
              <p className="fw-600 ft-16 valueDetails"> - </p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">
                {feeCalculationResponse?.percentageOfAccountBalanceAvailable}%
              </p>
            )}
          </span>
          <span
            className="mt-4 fw-500 ft-14 headerDetails"
            style={{ whiteSpace: "normal" }}
          >
            Exclude fully paid out participants from fee computation
            {feeCalculationResponse?.excludeFullyPaidOutParticipants == true ? (
              <p className="fw-600 ft-16 valueDetails">Yes</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">No</p>
            )}
          </span>

          <span className="mt-4 fw-500 ft-14 headerDetails">
            Run fee for
            {feeCalculationResponse?.runFeeFor == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"All Employees"}</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Active Employees"}</p>
            )}
          </span>

          {feeCalculationResponse?.feeType == 1 && (
            <span className="mt-4 fw-500 ft-14 headerDetails">
              Include loan balances in asset computations
              {feeCalculationResponse?.includeLoanBalancesInAssetComputation ==
              true ? (
                <p className="fw-600 ft-16 valueDetails">Yes</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">No</p>
              )}
            </span>
          )}
        </div>

        <div className="fee-calculation2"></div>

        <hr style={{ borderStyle: "dashed", color: " #000 " }}></hr>

        <div className="fw-600 ft-16 valueDetails">Fee Specification</div>
        <div className="fee-calculation1" style={{ whiteSpace: "normal" }}>
          <span className="mt-4 fw-500 ft-14 headerDetails">
            Specification name
            {[null, undefined, ""].includes(
              feeCalculationResponse?.feeSpecification?.name
            ) ? (
              <p
                className="fw-600 ft-16 valueDetails"
                style={{ whiteSpace: "nowrap" }}
              >
                {"-"}
              </p>
            ) : (
              <>
                {feeCalculationResponse?.feeSpecification?.name?.length <=
                40 ? (
                  <p className="fw-600 ft-16 valueDetails">
                    {feeCalculationResponse?.feeSpecification?.name}
                  </p>
                ) : (
                  <>
                    <AddToolTip
                      className="fw-600 ft-16 valueDetails"
                      name={feeCalculationResponse?.feeSpecification?.name}
                    >
                      {feeCalculationResponse?.feeSpecification?.name?.slice(
                        0,
                        10
                      )}
                      ...
                    </AddToolTip>
                  </>
                )}
              </>
            )}
          </span>

          <span
            className="mt-4 fw-500 ft-14 headerDetails"
            style={{ whiteSpace: "nowrap" }}
          >
            Specification description
            {[null, undefined, ""].includes(
              feeCalculationResponse?.feeSpecification?.description
            ) ? (
              <p className="fw-600 ft-16 valueDetails">{"-"}</p>
            ) : (
              <>
                {feeCalculationResponse?.feeSpecification?.description
                  ?.length <= 40 ? (
                  <p className="fw-600 ft-16 valueDetails">
                    {feeCalculationResponse?.feeSpecification?.description}
                  </p>
                ) : (
                  <>
                    <AddToolTip
                      className="fw-600 ft-16 valueDetails"
                      name={
                        feeCalculationResponse?.feeSpecification?.description
                      }
                    >
                      {feeCalculationResponse?.feeSpecification?.description?.slice(
                        0,
                        40
                      )}
                      ...
                    </AddToolTip>
                  </>
                )}
              </>
            )}
          </span>

          <span
            className="mt-4 fw-500 ft-14 headerDetails"
            style={{ whiteSpace: "nowrap" }}
          >
            Allocation type
            {feeCalculationResponse?.feeSpecification?.allocationType == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"Fixed Amount"}</p>
            ) : feeCalculationResponse?.feeSpecification?.allocationType ==
              2 ? (
              <p className="fw-600 ft-16 valueDetails">
                {"Percentage/Basis Points"}
              </p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Tiered"}</p>
            )}
          </span>
        </div>

        <div className="fee-calculation1">
          <span className="mt-4 fw-500 ft-14 headerDetails">
            Allocation sub-type
            <p className="fw-600 ft-16 valueDetails">
              {feeCalculationResponse?.feeSpecification
                ?.allocationTypespecificationSelected?.allocationSubType ==
              1 ? (
                <p className="fw-600 ft-16 valueDetails">{"Participant"}</p>
              ) : feeCalculationResponse?.feeSpecification?.allocationSubType ==
                2 ? (
                <p className="fw-600 ft-16 valueDetails">{"Plan"}</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">
                  {"Investment Based"}
                </p>
              )}
              {feeCalculationResponse?.feeSpecification?.allocationSubType ==
                null && <p className="fw-600 ft-16 valueDetails">{"-"}</p>}
            </p>
          </span>

          {feeCalculationResponse?.feeSpecification?.allocationSubType == 2 && (
            <span
              className="mt-4 fw-500 ft-14 headerDetails"
              style={{ whiteSpace: "nowrap" }}
            >
              Participant allocation
              {feeCalculationResponse?.feeSpecification
                ?.participantAllocation !== null ? (
                <p className="fw-600 ft-16 valueDetails">
                  {feeCalculationResponse?.feeSpecification
                    ?.participantAllocation === 1
                    ? "Prorated"
                    : "Equal"}
                </p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">{"-"}</p>
              )}
            </span>
          )}

          {feeCalculationResponse?.feeSpecification?.allocationType == 3 && (
            <p
              className="mt-4 fw-500 ft-14 headerDetails"
              style={{ whiteSpace: "nowrap" }}
            >
              Tier computation type
              {feeCalculationResponse?.feeSpecification?.tierComputationType ==
              1 ? (
                <p className="fw-600 ft-16 valueDetails">{"Step Rate"}</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">{"Exclusive"}</p>
              )}
              {feeCalculationResponse?.feeSpecification?.tierComputationType ==
                null && <p className="fw-600 ft-16 valueDetails">{"-"}</p>}
            </p>
          )}

          {feeCalculationResponse?.feeSpecification?.allocationType == 3 && (
            <p className="mt-4 fw-500 ft-14 headerDetails">
              Tier computation subtype
              {feeCalculationResponse?.feeSpecification
                ?.tierComputationSubType == 1 ? (
                <p className="fw-600 ft-16 valueDetails">{"Fixed Amount"}</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">
                  {"Percentage / Basis Points"}
                </p>
              )}
              {feeCalculationResponse?.feeSpecification
                ?.tierComputationSubType == null && (
                <p className="fw-600 ft-16 valueDetails">{"-"}</p>
              )}
            </p>
          )}
          {console.log(
            "spec",
            feeCalculationResponse?.feeSpecification?.allocationType,
            feeCalculationResponse?.feeSpecification?.allocationSubType
          )}
          {feeCalculationResponse?.feeSpecification?.allocationType == 1 &&
            //  (feeCalculationResponse?.feeSpecification?.allocationType == 3 &&
            feeCalculationResponse?.feeSpecification?.allocationSubType ==
              1 && (
              <p className="mt-4 fw-500 ft-14 headerDetails">
                Fee amount
                <p className="fw-600 ft-16 valueDetails">
                  {feeCalculationResponse?.feeSpecification?.feeAmount}
                </p>
              </p>
            )}

          {feeCalculationResponse?.feeSpecification?.formulaType == 2 && (
            <p
              className="mt-4 fw-500 ft-14 headerDetails"
              style={{ whiteSpace: "nowrap" }}
            >
              Fee basis points
              <p className="fw-600 ft-16 valueDetails">
                {
                  feeCalculationResponse?.feeSpecification
                    ?.feePercentageOrBasisPoints
                }{" "}
                BP
              </p>
            </p>
          )}
          {/* {feeCalculationResponse?.feeSpecification?.formulaType == null && 
          <>
            {"-"}
          </>
          } */}

          {(feeCalculationResponse?.feeSpecification?.allocationType == 2 ||
            (feeCalculationResponse?.feeSpecification?.allocationType == 3 &&
              feeCalculationResponse?.feeSpecification
                ?.tierComputationSubType == 2)) && (
            <p
              className="mt-4 fw-500 ft-14 headerDetails"
              style={{ whiteSpace: "nowrap" }}
            >
              Percentage / Basis Points
              {feeCalculationResponse?.feeSpecification?.formulaType == 1 ? (
                <p className="fw-600 ft-16 valueDetails">{"Percentage"}</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">{"Basis Points"}</p>
              )}
            </p>
          )}
          {feeCalculationResponse?.feeType == 1 &&
            feeCalculationResponse?.feeSpecification?.allocationType == 2 &&
            feeCalculationResponse?.feeSpecification?.formulaType == 1 &&
            feeCalculationResponse?.feeSpecification?.allocationSubType ==
              1 && (
              <p
                className="mt-4 fw-500 ft-14 headerDetails"
                style={{ whiteSpace: "nowrap" }}
              >
                Fee percentage
                <p className="fw-600 ft-16 valueDetails">
                  {
                    feeCalculationResponse?.feeSpecification
                      ?.feePercentageOrBasisPoints
                  }{" "}
                  %
                </p>
              </p>
            )}
        </div>
        <div style={{ marginLeft: "-20px" }}>
          <TieredParticiantBalance
            addSpecificationdata={feeCalculationResponse?.feeSpecification}
          />
        </div>
      </div>
    </div>
  );
};

export default FeeCalculation;
